import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { getDataDependency, getDisplayName } from 'gandi.react-helpers';
import createTranslatorProps from './createTranslatorProps';
import useTranslator from './useTranslator';
import { jsx as _jsx } from "react/jsx-runtime";
export default function withTranslator(options) {
  return WrappedComponent => {
    const namespace = options?.propsNamespace;
    const WithTranslator = props => {
      const translatorProps = useTranslator();
      const namespacedProps = namespace ? {
        [namespace]: translatorProps
      } : translatorProps;
      return /*#__PURE__*/_jsx(WrappedComponent, {
        ...props,
        ...namespacedProps
      });
    };
    WithTranslator.displayName = `WithTranslator(${getDisplayName(WrappedComponent)})`;
    const HoistedComponent = hoistNonReactStatic(WithTranslator, WrappedComponent);
    const wrapHandler = handlerName => {
      const wrappedHandler = getDataDependency(WrappedComponent, handlerName);
      if (!wrappedHandler) {
        return null;
      }
      HoistedComponent[handlerName] = (props, ...extra) => {
        const {
          res: {
            locals: {
              translator
            }
          }
        } = props;
        if (!translator) {
          console.error(`Missing translator in ${handlerName}`);
          return wrappedHandler(props, ...extra);
        }
        const translatorProps = createTranslatorProps(translator);
        const wrapperComponentProps = {
          ...props,
          ...(namespace ? {
            [namespace]: translatorProps
          } : translatorProps)
        };
        return wrappedHandler(wrapperComponentProps, ...extra);
      };
      return HoistedComponent;
    };
    wrapHandler('preFetch');
    wrapHandler('handleRedirect');
    wrapHandler('handleForm');
    return HoistedComponent;
  };
}